import http from './http'
let url = 'CartaoCreditoCieloConfiguracao/'
export function getCieloBandeiras() {
    return http.get(url + 'Bandeiras')
}
export function getConfigCielo() {
    return http.get(url)
}